<template>
  <el-dialog
    title="退换货收货地址修改"
    :visible.sync="visible"
    width="500px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div class="dialog-content">
      <p>批量导入修改信息</p>
      <el-form ref="uploadForm" :model="formData" :rules="rules">
        <el-form-item prop="file">
          <el-upload
            ref="upload"
            :action="uploadAction"
            :show-file-list="false"
            :on-change="handleFileChange"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
            :before-upload="handleBeforeUpload"
            :auto-upload="false"
            :limit="1"
            name="file"
            accept=".xlsx,.xls"
            :headers="headers"
            with-credentials
          >
            <el-button type="primary" :loading="uploading">
              {{ uploading ? "导入中..." : "选择文件" }}
            </el-button>
            <span v-if="fileName" class="file-name">{{ fileName }}</span>
          </el-upload>
        </el-form-item>
      </el-form>
      <p>
        <el-button type="text" @click="handleDownloadTemplate"
          >下载模板</el-button
        >
        每次导入最多5000条
        <el-button
          v-if="errorFileUrl"
          type="text"
          style="color: red"
          @click="handleDownloadError"
          >下载错误信息</el-button
        >
      </p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :loading="uploading" @click="handleSubmit">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";
import { exportExchangeGoodsExpressBackLink } from "@/api/update-supply.js";
import { downloadByUrl } from "@/utils/export.js";

export default {
  name: "ImportReturnAddressDialog",

  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      visible: false,
      uploading: false,
      fileName: "",
      formData: {
        file: null,
      },
      rules: {
        file: [{ required: true, message: "请选择文件", trigger: "change" }],
      },
      uploadAction: `${apiBaseURL}/erp/Supply/importExchangeGoodsExpressBack`,
      headers: {
        Authorization: localStorage.getItem("token") || "",
      },
      errorFileUrl: "",
    };
  },

  watch: {
    show: {
      immediate: true,
      handler(val) {
        this.visible = val;
      },
    },
  },

  methods: {
    handleClose() {
      this.fileName = "";
      this.formData.file = null;
      this.errorFileUrl = "";
      this.uploading = false;
      this.$refs.upload?.clearFiles();
      this.$emit("close");
    },
    handleFileChange(file) {
      this.$refs.upload.clearFiles();
      this.uploading = false;
      this.errorFileUrl = "";

      this.$nextTick(() => {
        if (file && file.raw) {
          this.formData.file = file.raw;
          this.fileName = file.raw.name;
        }
      });
    },
    handleBeforeUpload(file) {
      const isExcel = /\.(xlsx|xls)$/.test(file.name.toLowerCase());
      if (!isExcel) {
        this.$message.error("只能上传 Excel 文件！");
        this.uploading = false;
        return false;
      }
      this.formData.file = file;
      this.fileName = file.name;
      this.errorFileUrl = "";
      return true;
    },

    handleUploadSuccess(res) {
      this.uploading = false;
      if (res.code === 200) {
        this.$message.success("导入成功");
        this.$emit("success");
        this.handleClose();
      } else {
        this.formData.file = null;
        this.$message.error(res.msg || "导入失败");
      }
    },

    handleUploadError(err) {
      this.uploading = false;
      this.formData.file = null;
      console.error("上传错误详情:", err);
      this.$message.error(err.message || "导入失败");
    },

    handleSubmit() {
      this.$refs.uploadForm.validate((valid) => {
        if (!valid) {
          this.$message.warning("请选择文件");
          return;
        }

        if (!this.formData.file) {
          this.$message.warning("请选择文件");
          return;
        }

        this.uploading = true;
        this.customUpload();
      });
    },

    async handleDownloadTemplate() {
      try {
        const res = await exportExchangeGoodsExpressBackLink();
        console.log("res", res.data.data);
        if (res.data.code === 200) {
          downloadByUrl(res.data.data.file);
        } else {
          this.$message.error(res.msg || "下载失败");
        }
      } catch (err) {
        this.$message.error("下载失败");
      }
      this.$refs.upload?.clearFiles();
    },

    customUpload() {
      this.errorFileUrl = "";

      if (!this.formData.file) {
        this.$message.error("没有选择文件");
        this.uploading = false;
        return;
      }

      const formData = new FormData();
      formData.append("excel", this.formData.file);

      this.$http({
        url: this.uploadAction,
        method: "post",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          ...this.headers,
        },
      })
        .then((res) => {
          if (res.data.code !== 200 && res.data.data && res.data.data.file) {
            this.errorFileUrl = res.data.data.file;
          }
          this.handleUploadSuccess(res.data);
        })
        .catch((err) => {
          console.error("Upload error:", err);
          this.handleUploadError(err);
        });
    },

    handleDownloadError() {
      if (!this.errorFileUrl) {
        this.$message.warning("没有错误信息文件");
        return;
      }

      downloadByUrl(this.errorFileUrl);
    },
  },
};
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}

.file-name {
  margin-left: 10px;
  color: #606266;
}
</style>



// WEBPACK FOOTER //
// src/pages/supply/components/ImportReturnAddressDialog.vue